export default __webpack_public_path__ + "static/media/blob purple.bbd73695.svg";